import React from 'react';
import { Barcode } from '../shared/Barcode';
import { fmtNumeric } from '../../utils/bn';
interface BarcodeStickerProps {
  pcr: string;
  serial: string;
  regNo: string;
  date: string;
  voided?: boolean;
}
export function BarcodeSticker({
  pcr,
  serial,
  regNo,
  date,
  voided = false
}: BarcodeStickerProps) {
  return <div className="print-area relative mx-auto w-full max-w-[340px] rounded-md border-2 border-ink bg-white p-3 text-ink" data-id="element-161" data-mp="282c70rppqs7i">
      <div className="flex items-center justify-between border-b border-ink pb-1.5" data-id="element-162" data-mp="1t8h4s4k2c15a">
        <span className="text-[11px] font-bold tracking-wider" data-id="element-163" data-mp="1y70r462kjey6">DMP VEHICLE CUSTODY</span>
        <span className="text-[10px] font-mono" data-id="element-164" data-mp="1k6zp2naki1h4">{serial}</span>
      </div>
      <p className="mt-1.5 text-center font-mono text-lg font-bold tracking-wide" data-id="element-165" data-mp="1p3zmk9tcpvwm">{pcr}</p>
      <Barcode value={pcr} height={58} showText={false} className="mt-1" data-id="element-166" data-mp="3ej64jyahv4f8" />
      <div className="mt-1.5 flex justify-between text-[11px]" data-id="element-167" data-mp="3jisg83aocclx">
        <span data-id="element-168" data-mp="3jiadcntib051">Registration: <b data-id="element-169" data-mp="3jgpq7j9iujh7">{regNo}</b></span>
        <span data-id="element-170" data-mp="d32ozhltupys">Date: <b data-id="element-171" data-mp="d2szrw8lwmu5">{fmtNumeric(date)}</b></span>
      </div>
      {voided && <div className="absolute inset-0 flex items-center justify-center bg-white/70" data-id="element-172" data-mp="91phl3336epr">
          <span className="rotate-[-10deg] rounded border-2 border-danger px-3 py-1 text-sm font-bold text-danger" data-id="element-173" data-mp="8zwkofi9z8uy">বাতিল — বৈধ নয়</span>
        </div>}
    </div>;
}